export default __webpack_public_path__ + "static/pe-cases-bulk-assign-c0e958410e0d3493a3b1427f1f679e0e.mp4";